
export { getUrlMetaInfo };
const getUrlMetaInfo = (url, jp, sp, emertNo, recallDate, getEnvVar) => {
  // Note: sp could be null
  if (url && url.indexOf('meta') !== -1) return url;
  
  let jpmfg = jp && jp.Manufacturers || null;
  let spmfg = sp && sp.Manufacturers || null; 

  const name = jp && jp.FIRMLEGALNAM || sp && sp.FIRMLEGALNAM || null;

  const jpContactConsumer = jp?.Contacts?.Consumers?.length && jp.Contacts.Consumers[0] || '';
  const spContactConsumer = sp?.Contacts?.Consumers?.length && sp.Contacts.Consumers[0] || '';
  const jpContactMedia = jp?.Contacts?.Media?.length && jp.Contacts.Media[0] || '';
  const spContactMedia = sp?.Contacts?.Media?.length && sp.Contacts.Media[0] || '';

  const extractEmail = (obj, field) => {
    let valueArray = [];
    if (obj.Contacts && obj.Contacts[field] && obj.Contacts[field].length) {
      obj.Contacts[field].forEach((val, i) => {
        if (val && val.includes('@') && val.includes('.')) {
          const emailAtPosBg = val.indexOf('@');
          const emailNamePosBg = val.substring(0, emailAtPosBg).lastIndexOf(' ') + 1;

          if (emailNamePosBg === 0) {
            valueArray.push(val);
          } else {
            const emailPre = val.substring(0, emailNamePosBg);
            const emailAndPost = val.substr(emailNamePosBg);
            const emailHostPosEn = emailPre.length + emailAndPost.indexOf(' ');
            const email = val.substring(emailNamePosBg, emailHostPosEn);
            const emailPost = val.substr(emailHostPosEn);
            valueArray.push(email);
	  }
	}
      });
    }
    return valueArray || [];
  }

  const replSpclChar = (str, char, replChar) => {
    // Having '%' in mfg/contact/desc causes failure on server side when using decodeURIComponent()
    // '&' has no problem
    // '?' has no problem
    // '%' has issues.
    // To test, search recall for 'meatbird', it's a cargil recall
    return str.replace(char, replChar);
  }

  // If mfg array has a large Name value then we truncate it to 120 chars.
  // On the backend, the createLogosApprover() has issues when writing to DB.
  let mfgCharLimit = 120;

  //let probChar = '%', useChar = ' percent';
  let probChar = '%', useChar = ' percent';
  
  let jpmedia = jp && extractEmail(jp, 'Media') || null;
  let spmedia = sp && extractEmail(sp, 'Media') || null;

  let jpconsumers = jp && extractEmail(jp, 'Consumers');
  let spconsumers = sp && extractEmail(sp, 'Consumers');

  let jpcontacts = jp && jpmedia.concat(jpconsumers);
  let spcontacts = sp && spmedia.concat(spconsumers);

  let desc = '';
  let len = jp.Description.indexOf(' is ') == -1 ? 40 : jp.Description.indexOf(' is ')
  if (len > 40) len = 40;
  desc = jp.Description ? jp.Description.substr(0, len) :
    sp.Description ? sp.Description.substr(0, sp.Description.indexOf('is')) : '';

  jpmfg = jpmfg && jpmfg.map(mfgObj => {
    if (mfgObj && mfgObj.Name) {
      mfgObj.Name = replSpclChar(mfgObj.Name, probChar, useChar);
    }
    return mfgObj
  });

  spmfg = spmfg && spmfg.map(mfgObj => {
    if (mfgObj && mfgObj.Name) {
      mfgObj.Name = replSpclChar(mfgObj.Name, probChar, useChar);
    }
    return mfgObj
  });

  let mfg = jpmfg || spmfg;
  mfg = jpmfg && spmfg && jpmfg.concat(spmfg) || mfg;

  if (name) {
    if (mfg && mfg.length) mfg.push( { "Name": replSpclChar(name.trim(), probChar, useChar)} ) ;
    else {
      mfg = [{ "Name":  replSpclChar(name.trim(), probChar, useChar) }]; 
    }
  }

  if (jpContactConsumer) {
    if (mfg && mfg.length) mfg.push( { "Name": replSpclChar(jpContactConsumer.trim(), probChar, useChar)} ) ;
    else {
      mfg = [{ "Name":  replSpclChar(jpContactConsumer.trim(), probChar, useChar) }]; 
    }
  }

  if (!jpContactConsumer && spContactConsumer) {
    if (mfg && mfg.length) mfg.push( { "Name": replSpclChar(spContactConsumer.trim(), probChar, useChar)} ) ;
    else {
      mfg = [{ "Name":  replSpclChar(spContactConsumer.trim(), probChar, useChar) }]; 
    }
  }

  if (jpContactMedia) {
    if (mfg && mfg.length) mfg.push( { "Name": replSpclChar(jpContactMedia.trim(), probChar, useChar)} ) ;
    else {
      mfg = [{ "Name":  replSpclChar(jpContactMedia.trim(), probChar, useChar) }]; 
    }
  }

  if (!jpContactMedia && spContactMedia) {
    if (mfg && mfg.length) mfg.push( { "Name": replSpclChar(spContactMedia.trim(), probChar, useChar)} ) ;
    else {
      mfg = [{ "Name":  replSpclChar(spContactMedia.trim(), probChar, useChar) }]; 
    }
  }
  
  jpcontacts = jpcontacts && jpcontacts.map(m => {
    if (m) {
      m = replSpclChar(m, probChar, useChar);
    }
    return m;
  });
  spcontacts = spcontacts && spcontacts.map(m => {
    if (m) {
      m = replSpclChar(m, probChar, useChar);
    }
    return m;
  });
  let contacts = jpcontacts || spcontacts;
  contacts = jpcontacts && spcontacts && jpcontacts.concat(spcontacts) || contacts;

  // make it a string array of unique entries
  let mfgStrList = [];
  mfg && mfg.forEach( m => {
    if (m.Name.length > mfgCharLimit) {
      m.Name = m.Name.substr(0, mfgCharLimit);
    }
    if (!mfgStrList.includes(m.Name)) {
      mfgStrList.push(m.Name);
    }
  });

  // make it a string array of unique entries
  let contactsStrList = [];
  contacts && contacts.forEach( c => !contactsStrList.includes(c) ? contactsStrList.push(c) : null );

  const meta = {
    mfg: mfgStrList,               // array of { name: 'xxxx' }
    contacts: contactsStrList,
    desc: desc && replSpclChar(desc.trim(), probChar, useChar) || '',
    url: url,
    emertNo: emertNo,
    recallDate: recallDate,
  };

  let stringifiedObject = JSON.stringify(meta);
  let encodedObject = encodeURIComponent(stringifiedObject);
  let baseUrl = getEnvVar.API_SRVR_IMGS_URL + "/imgsSvc";
  let urlWithJson = baseUrl + "?service=image&meta=" + encodedObject;

  return urlWithJson;
}

